"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from "react";
import makeStyles from "../../theming/make-styles.js";
import isElement from "../utils/is-element.js";
import useCombinedRefs from "../utils/use-combined-refs.js";
const useStyles = makeStyles()((theme, { block, color, direction }) => {
    const palette = theme.palette(color).formGroup;
    return {
        group: {
            display: "grid",
            gridTemplateColumns: direction === "horizontal"
                ? `
        [label-start] minmax(min-content, max-content)
        [label-end input-start] ${block ? "1fr" : "minmax(min-content, max-content)"} [input-end]`
                : `
        [label-start input-start] ${block ? "1fr" : "minmax(min-content, max-content)"} [label-end input-end]`,
            gridTemplateRows: "[label-start] min-content [label-end input-start] 1fr [input-end]",
            columnGap: direction === "horizontal" ? theme.spacing("md") : undefined,
            width: block ? "100%" : undefined,
            marginBottom: theme.spacing("lg"),
        },
        label: {
            display: "inline-flex",
            alignSelf: "center",
            marginBottom: direction === "vertical" ? theme.spacing("xs") : undefined,
            fontSize: theme.typography.label.fontSize,
            fontWeight: theme.typography.fontWeights.medium,
            color: palette.color,
        },
    };
});
export const FormGroup = React.forwardRef(function FormGroup(_a, ref) {
    var { block, children, className, color = "text", direction = "vertical", label } = _a, props = __rest(_a, ["block", "children", "className", "color", "direction", "label"]);
    const { classes, cx } = useStyles({ block, direction, color });
    const innerRef = useRef(ref);
    const combinedRef = useCombinedRefs(ref, innerRef);
    const handleLabelClick = useCallback((e) => {
        var _a, _b, _c;
        if (isElement(label) && "onClick" in label.props)
            label.props.onClick(e);
        const input = ((_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input")) || ((_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.querySelector("textarea")) || ((_c = innerRef.current) === null || _c === void 0 ? void 0 : _c.querySelector("button"));
        input === null || input === void 0 ? void 0 : input.focus();
    }, [label]);
    return (_jsxs("div", Object.assign({ ref: combinedRef, "aria-orientation": direction, className: cx(classes.group, className), "data-component": "form-group" }, props, { children: [isElement(label)
                ? React.cloneElement(label, {
                    className: cx(classes.label, label.props.className),
                    onClick: handleLabelClick,
                })
                : (label || typeof label === "number") && (_jsx("label", { className: classes.label, onClick: handleLabelClick, children: label })), children] })));
});
export default FormGroup;
//# sourceMappingURL=form-group.js.map